import { compose } from 'recompose';
import { withRouter } from 'react-router';
import FeedGridItem from './FeedGridItem';
import withAnalytics from '../../../containers/redux/withAnalytics';

const FeedGridItemAnalytics = compose(
  withRouter,
  withAnalytics
)(FeedGridItem);

FeedGridItemAnalytics.displayName = FeedGridItem.displayName;

export default FeedGridItemAnalytics;
